/* import { NgModule } from '@angular/core';
import { DateRangeFilterComponent } from './filter-date/date-range-filter.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';

@NgModule({
    imports: [
        FuseSharedModule,
        MatFormFieldModule,
        MatInputModule,
        
        MatSelectModule,
        MatButtonModule,
        MatNativeDateModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        CalendarModule,
        TranslateModule,
        MatDatepickerModule,
    ],
    declarations: [DateRangeFilterComponent],
    exports: [DateRangeFilterComponent,FuseSharedModule,
        MatFormFieldModule,
        MatInputModule,
        
        MatSelectModule,
        MatButtonModule,
        MatNativeDateModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        CalendarModule,
        
        TranslateModule,
        MatDatepickerModule,]
})
export class AppComponentsModule { } */
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FuseSidebarModule } from '@fuse/components';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { AppDirectivesModule } from '../directives/app-directives.module';
import { DateRangeFilterComponent } from './filter-date/date-range-filter.component';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { CalendarModule } from 'angular-calendar';
import { AppSharedModule } from 'app/shared.module';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { AddEntityComponent } from './add-entity/add-entity.component';

@NgModule({
    imports: [

        AppDirectivesModule,

        MatRippleModule,
        MatSelectModule,
        MatMenuModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatAutocompleteModule,

        TranslateModule,

        ToastModule,
        TableModule,

        FuseSidebarModule,
        FuseSharedModule,
        MatTooltipModule,

    ],
    declarations: [DateRangeFilterComponent, AddEntityComponent],
    exports: [

        AppDirectivesModule,

        MatRippleModule,
        MatSelectModule,
        MatMenuModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatSlideToggleModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatAutocompleteModule,

        TranslateModule,

        ToastModule,
        TableModule,

        FuseSidebarModule,
        DateRangeFilterComponent,
        AddEntityComponent

    ]
})
export class AppComponentsModule { }